import { FilterProperty, IFilter } from "@/types/filter.types";
import { RequestPagination } from "@/types/requests.types";

export function buildPaginationQuery(pagination: RequestPagination): string {
  const { pageNumber, pageSize } = pagination;
  return `pageNumber=${pageNumber}&pageSize=${pageSize}`;
}

export function buildSortQuery(sortBy: string | null, sortDirection: string | null): string {
  if (!sortBy || !sortDirection) return "";
  return `&sortBy=${encodeURIComponent(sortBy)}&sortDirection=${encodeURIComponent(sortDirection)}`;
}

export const normalizeSingleFilterFormData = <T>(
  formData: IFilter<T>[],
  defaultProperty: FilterProperty<T>
) => {
  if (formData[0]?.property === "all") {
    return [{ ...formData[0], property: defaultProperty }];
  }
  return formData;
};

/** Remove filtros com valor vazio antes de enviar à API. */
export const sanitizeFilters = <T>(filters: IFilter<T>[]): IFilter<T>[] => {
  return filters.filter((filter) => {
    const { value } = filter;
    // `null` can be a valid filter value (e.g. equals null)
    if (value === undefined) return false;
    if (typeof value === "string" && value.trim() === "") return false;
    return true;
  });
};
